/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Link, useLocation } from "react-router";
import { mergeSx } from "@/src/utils/mergeSx";
import { authenticatedNavigationStyle } from "@/src/components/AuthenticatedNavigation/authenticatedNavigationStyle";
import { getCaseLink } from "@/src/services/productService";
import { Box, ListItemButton, Typography } from "@mui/material";
import { translate } from "@/src/services/translations/translations";
import { Error } from "@mui/icons-material";
import { MinimalCase } from "@/src/types/Entities/MinimalCase";
import { useHeader } from "@/src/components/Header/HeaderProvider";

export type AuthenticatedNavigationLinkCaseProps = {
  product: MinimalCase;
  hasInquiry?: boolean;
};

export default function AuthenticatedNavigationLinkCase({ product, hasInquiry }: AuthenticatedNavigationLinkCaseProps) {
  const location = useLocation();
  const { setMobileNavActive } = useHeader();

  const caseLink = getCaseLink(product);
  const isActive = (location.pathname + "/").startsWith(caseLink + "/");

  return (
    <ListItemButton
      component={Link}
      sx={mergeSx(authenticatedNavigationStyle.link, isActive && authenticatedNavigationStyle.linkActive)}
      to={caseLink}
      onClick={() => setMobileNavActive?.(false)}
    >
      <Typography component={"span"} sx={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}>
        {translate(product.name + ".label", {}, "")} {product.reference}
      </Typography>
      {hasInquiry && (
        <Box component={"span"} sx={authenticatedNavigationStyle.inquiryIcon}>
          <Error color={"warning"} />
        </Box>
      )}
    </ListItemButton>
  );
}
